import { call, put, take, actionChannel } from "redux-saga/effects";

import { POST } from "../types/request.types";
import { requestHandler } from "./fetcher.saga";
import { buffers } from "redux-saga";
import {
  REQUEST_CREATE_TOKEN_STRIPE_FINISHED,
  REQUEST_CREATE_TOKEN_STRIPE,
  PRE_CREATE_TOKEN_STRIPE,
  CREATE_TOKEN_STRIPE,
} from "../types/restaurant.types";

export function* preCreateTokenStripeRestaurant() {
  while (true) {
    const action = yield take(PRE_CREATE_TOKEN_STRIPE);
    const { authCode, idRestaurant } = action;
    yield put({
      type: REQUEST_CREATE_TOKEN_STRIPE,
      body: {
        authCode,
        idRestaurant,
      },
    });

    const { response } = yield take(REQUEST_CREATE_TOKEN_STRIPE_FINISHED);
    yield put({
      type: CREATE_TOKEN_STRIPE,
      response: response.data.success,
      message: response.data.message,
      stripeUserId: response.data.stripeUserId,
    });
  }
}

export function* watchCreateTokenStripeRestaurant() {
  const requestChan = yield actionChannel(
    REQUEST_CREATE_TOKEN_STRIPE,
    buffers.expanding()
  );
  const storageToken =
    (typeof window !== "undefined" &&
      window.localStorage.getItem("refreshToken")) ||
    "";
  while (true) {
    const action = yield take(requestChan);
    const result = yield call(
      requestHandler,
      POST,
      `restaurant/admin/token/${action.body.idRestaurant}/${action.body.authCode}`,
      {},
      storageToken
    );
    yield put({
      type: REQUEST_CREATE_TOKEN_STRIPE_FINISHED,
      response: result,
    });
  }
}
